import i18n from '@/plugins/i18n';

export class Address {
    public street?: string;
    public number?: string;
    public details?: string;
    public postalCode?: string;
    public city?: string;
    public stateId?: number;
    public stateName?: string;
    public countryId?: number;
    public countryName?: string;
    public latitude?: number;
    public longitude?: number;


    constructor(json?: any) {
        if (!json) {
            return;
        }

        Object.assign(this, json);
    }

    public get fullAddress(): string {
        return [
            this.street,
            this.number,
            (this.street || this.number ? '<br/>' : undefined),
            this.details,
            (this.details ? '<br/>' : undefined),
            `${(this.city ? this.city : '')}${(this.city ? ' ' : '')}${(this.postalCode ? this.postalCode : '')}`,
            (this.city || this.postalCode ? '<br/>' : undefined),
            this.stateName,
            this.localizedCountryName,
        ].filter(Boolean).join(', ').replace(/\<br\/>, /gi, '<br/>');
    }

    public get localizedCountryName(): string | undefined {
        return this.countryId
            ? i18n.t(`common.countries.${this.countryId}.name`).toString()
            : undefined;
    }

    public isEmpty(): boolean {
        return !this.street ||
            !this.postalCode ||
            !this.city ||
            !this.stateId ||
            !this.countryId;
    }

    public getInOneLine(): string {
        let addressToQuery = '';

        if (this.street) {
            addressToQuery = this.street;

            if (this.number) {
                addressToQuery += ` ${this.number}`;
            }
        }

        if (this.city) {
            if (addressToQuery) {
                addressToQuery += ',';
            }

            addressToQuery += this.city;
        }

        if (this.postalCode) {
            if (addressToQuery) {
                addressToQuery += ',';
            }

            addressToQuery += this.postalCode;
        }

        if (this.stateName) {
            if (addressToQuery) {
                addressToQuery += ',';
            }

            addressToQuery += this.stateName;
        }

        return addressToQuery;
    }

    public setLocation(latitude: number, longitude: number): void {
        this.latitude = latitude;
        this.longitude = longitude;
    }

    public clone(): Address {
        const address: Address = new Address();

        address.street = this.street;
        address.number = this.number;
        address.details = this.details;
        address.postalCode = this.postalCode;
        address.city = this.city;
        address.stateId = this.stateId;
        address.stateName = this.stateName;
        address.countryId = this.countryId;
        address.countryName = this.countryName;
        address.latitude = this.latitude;
        address.longitude = this.longitude;

        return address;
    }
}
